export const inputThemeUpdated = {
  border: {
    bottom: '2px',
  },
};
